<template>
  <div>
    <div v-if="isMoreThan" class="row">
      <div class="col-xs-12 col-md-2 q-mx-auto">
        <q-select
          outlined
          bottom-slots
          v-model="formData[0].logic"
          :options="optionLogic"
          dense
          label="Choose Logic"
          single
          class="q-mx-sm"
          :menu-absolute="true"
          :bg-color="$q.dark.mode ? 'grey-9' : 'grey-3'"
        >
        </q-select>
      </div>
    </div>
    <q-list bordered class="q-py-md">
      <div class="row">
        <div class="col-6">
          <span class="q-pa-sm text-bold">
            EMA Setup

            <q-tooltip class="bg-primary">
              Exponential Moving Average
            </q-tooltip>
          </span>
        </div>
        <div class="col-6 text-left q-pa-sm">
          <span class="text-center">
            <q-btn rounded color="primary" label="+" @click="duplicateForm()">
              <q-tooltip class="bg-primary"> click to add new setup </q-tooltip>
            </q-btn>
          </span>
        </div>
      </div>

      <div v-for="(form, index) in formData" :key="index">
        <q-separator />
        <div v-if="index > 0" class="row">
          <div class="col-xs-12 col-md-2 q-mt-md q-mx-auto">
            <q-select
              outlined
              bottom-slots
              v-model="form.logic"
              :options="optionLogic"
              dense
              label="Choose Logic"
              single
              class="q-mx-sm"
              :menu-absolute="true"
              :bg-color="$q.dark.mode ? 'grey-9' : 'grey-3'"
            >
            </q-select>
          </div>
        </div>
        <q-separator />

        <div class="row q-py-sm">
          <div v-if="!isBackTest" class="col-xs-12 col-md-2">
            <q-select
              outlined
              bottom-slots
              v-model="form.scanning_type"
              :options="optionScanningType"
              dense
              label="Scanning type"
              single
              class="q-mx-sm ellipsis"
              :bg-color="$q.dark.mode ? 'grey-9' : 'grey-3'"
              :menu-absolute="true"
            >
              <template v-slot:hint>
                Scanning type {{ form.scanning_type }}
              </template>
            </q-select>
          </div>
          <div class="col-xs-12 col-md-2">
            <q-select
              outlined
              bottom-slots
              v-model="form.time_period"
              :options="optionTimePeriod"
              dense
              label="Choose time period"
              single
              class="q-mx-sm ellipsis"
              :bg-color="$q.dark.mode ? 'grey-9' : 'grey-3'"
              :menu-absolute="true"
            >
              <template v-slot:hint>Time Period </template>
            </q-select>
          </div>

          <div class="col-xs-12 col-md-2">
            <q-select
              outlined
              bottom-slots
              v-model="form.source"
              :options="optionSource"
              dense
              label="Choose Source"
              single
              class="q-mx-sm"
              :menu-absolute="true"
            >
              <template v-slot:hint> Source </template>
            </q-select>
          </div>

          <div class="col-xs-12 col-md-1">
            <q-select
              outlined
              dense
              bottom-slots
              v-model="form.condition"
              :options="optionCondition"
              label="Greater than/Less than"
              single
              class="q-mx-sm ellipsis"
              :menu-absolute="true"
              :bg-color="$q.dark.mode ? 'green-8' : 'green-2'"
            >
              <template v-slot:hint> Greater/Less Than </template>
            </q-select>
          </div>
          <div class="col-xs-12 col-md-2">
            <q-select
              outlined
              bottom-slots
              v-model="form.ema_source"
              :options="optionSource"
              dense
              label="Choose Source"
              single
              class="q-mx-sm"
              :menu-absolute="true"
            >
              <template v-slot:hint> EMA Source </template>
            </q-select>
          </div>

          <div class="col-xs-12 col-md-2">
            <q-input
              dense
              outlined
              v-model="form.length"
              label="EMA Length"
              placeholder="Placeholder"
              hint="Enter EMA Length"
              type="number"
              class="q-mx-sm"
            />
          </div>

          <q-space />

          <div v-if="formData.length > 1" class="col-xs-12 col-md-1">
            <q-icon
              class="cursor-pointer q-ml-md q-pa-md"
              size="sm"
              color="red"
              name="delete"
              @click="onclickDelete(formData, index)"
            >
              <q-tooltip class="bg-red">delete</q-tooltip>
            </q-icon>
          </div>
        </div>
      </div>
    </q-list>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import useUtils from "src/use/utils";
export default {
  props: {
    setDataFromBackend: {
      type: Boolean,
      default: false,
    },
    setup_data: {
      type: Object,
    },
    isMoreThan: {
      type: Boolean,
      default: false,
    },
    isBackTest: {
      type: Boolean,
      default: false,
    },
    buySellType: {
      type: String,
    },
  },
  emits: ["formData"],
  setup(props, context) {
    const {
      form,
      optionTimePeriod,
      optionScanningType,
      optionSource,
      optionLogic,
      optionCondition,
    } = useUtils();
    const formData = ref([
      {
        ...form,
        condition:
          props.buySellType === "buy"
            ? ">"
            : props.buySellType === "sell"
            ? "<"
            : "",
        ema_source: "close",
        length: 21,
      },
    ]);
    const duplicateForm = () => {
      const newForm = { ...formData.value[0] };
      formData.value.push(newForm);
    };

    const onclickDelete = (data, index) => {
      data.splice(index, 1);
    };
    context.emit("formData", formData.value);
    const setData = () => {
      if (props.setDataFromBackend == true) {
        formData.value = [];
        for (let i in props.setup_data) {
          const newForm = {};
          for (let key in props.setup_data[i]) {
            newForm[key] = props.setup_data[i][key];
          }
          formData.value.push(newForm);
        }
      }
    };

    onMounted(() => {
      setData();
    });

    watch(props, (newVal, oldVal) => {
      setData();
    });
    watch(
      () => formData.value,
      (newVal, oldVal) => {
        context.emit("formData", newVal);
      }
    );
    return {
      formData,
      onclickDelete,
      duplicateForm,
      optionTimePeriod,
      optionScanningType,
      optionSource,
      optionLogic,
      optionCondition,
    };
  },
};
</script>
